export * from "./QuizMultiQuestion";
